module.exports = __webpack_public_path__ + "874a9dbadd8394e2c358bd548f9a2ebd.woff";